"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDecimal128Value = exports.isNullableIntegerValue = exports.isNullableNumberValue = exports.isIntegerValue = exports.isNotNanValue = exports.isNanValue = exports.isNotNegativeNumberValue = void 0;
const primitives_1 = require("./primitives");
const typing_1 = require("./typing");
const isNotNegativeNumberValue = (fieldValue) => {
    return (0, primitives_1.isNumberValue)(fieldValue) && fieldValue >= 0;
};
exports.isNotNegativeNumberValue = isNotNegativeNumberValue;
const isNanValue = (fieldValue) => {
    return Number.isNaN(Number(fieldValue));
};
exports.isNanValue = isNanValue;
const isNotNanValue = (fieldValue) => {
    return !(0, exports.isNanValue)(fieldValue);
};
exports.isNotNanValue = isNotNanValue;
const isIntegerValue = (fieldValue) => {
    return (0, primitives_1.isNumberValue)(fieldValue) && Number.isInteger(fieldValue);
};
exports.isIntegerValue = isIntegerValue;
const isNullableNumberValue = (fieldValue) => {
    return (0, typing_1.Union)(primitives_1.isNumberValue, primitives_1.isNullValue)(fieldValue);
};
exports.isNullableNumberValue = isNullableNumberValue;
const isNullableIntegerValue = (fieldValue) => {
    return (0, typing_1.Union)(exports.isIntegerValue, primitives_1.isNullValue)(fieldValue);
};
exports.isNullableIntegerValue = isNullableIntegerValue;
const isDecimal128Value = (fieldValue) => {
    return ((0, primitives_1.isStringValue)(fieldValue) && (0, typing_1.Union)(exports.isNotNanValue, primitives_1.isNullValue)(fieldValue));
};
exports.isDecimal128Value = isDecimal128Value;
